import React from 'react';

import {Code, FlexView, Heading, Spacer} from '/component/base/Storybook';

import Icon from '../Icon';

export default () => (
  <>
    <Heading level={2}>Social Icons</Heading>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="Facebook" />
        <Spacer size={6} />
        <Code>{'Facebook'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="Twitter" />
        <Spacer size={6} />
        <Code>{'Twitter'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="social-youtube" />
        <Spacer size={6} />
        <Code>{'social-youtube'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="social-pinterest" />
        <Spacer size={6} />
        <Code>{'social-pinterest'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="social-instagram" />
        <Spacer size={6} />
        <Code>{'social-instagram'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="social-tumblr" />
        <Spacer size={6} />
        <Code>{'social-tumblr'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="social-wechat" />
        <Spacer size={6} />
        <Code>{'social-wechat'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="social-linkedin" />
        <Spacer size={6} />
        <Code>{'social-linkedin'}</Code>
      </FlexView>
    </FlexView>
    <Spacer size={16} />
    <FlexView direction="horizontal">
      <FlexView align="center">
        <Icon name="social-vk" />
        <Spacer size={6} />
        <Code>{'social-vk'}</Code>
      </FlexView>
      <Spacer direction="horizontal" size={16} />
      <FlexView align="center">
        <Icon name="social-reddit" />
        <Spacer size={6} />
        <Code>{'social-reddit'}</Code>
      </FlexView>
    </FlexView>
  </>
);
